// src/components/WelcomeIntro/WelcomeIntro.js
import React, { useState, useEffect } from 'react';
import {
  Sparkles,
  TrendingUp,
  Users,
  Zap,
  ExternalLink,
  ChevronRight
} from 'lucide-react';
import './WelcomeIntro.css';
import Newsboard from '../Newsboard/Newsboard';

const WelcomeIntro = ({ user, userProfile, setActiveTab }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const highlights = [
    {
      icon: TrendingUp,
      title: 'DeFi 대출 시장 급성장',
      description: '72% 성장으로 1,270억 달러 규모 달성',
      color: '#667eea'
    },
    {
      icon: Zap,
      title: 'AI 기술 도입 가속화',
      description: '코인베이스, AI 생성 코드 50% 목표',
      color: '#764ba2'
    },
    {
      icon: Users,
      title: '규제 명확성 확보',
      description: 'SEC & CFTC 현물 거래 허용 발표',
      color: '#e74c3c'
    }
  ];

  const news = [
    {
      badge: '🔥 HOT',
      title: '비트코인 111,000달러 돌파',
      description: '2주간 하락 추세 반등 성공',
      link: '#'
    },
    {
      badge: '🚀 NEW',
      title: 'US GDP 온체인 발표 실험',
      description: '블록체인 정부 통합 시작',
      link: '#'
    },
    {
      badge: '💡 TECH',
      title: 'WorldLand 생태계 구축',
      description: 'DApp 개발자 커뮤니티 확대',
      link: '#'
    }
  ];

  return (
    <div className="home-intro-container">

      <div className="hero-video-wrapper">
        <div className={`video-container ${isVideoLoaded ? 'loaded' : ''}`}>
          <img
            src="/images/welcomeToChat.png"
            alt="WorldLand Blockchain Introduction"
            className="hero-video"
            onLoad={() => setIsVideoLoaded(true)}
          />
          {!isVideoLoaded && (
            <div className="video-loading">
              <div className="spinner"></div>
            </div>
          )}
        </div>
        {/* <div className="newsboard-page"> */}
        <Newsboard user={user} userProfile={userProfile} setActiveTab={setActiveTab} />
        {/* </div> */}
      </div>
    </div>
  );
};

export default WelcomeIntro;